'use strict';

import * as types from './types';
import qs from 'qs';

export const fetchJob = jobId => ({
	type: types.FETCH_JOB,
	meta: {
		async: true,
		endPoint: `/jobs/${ jobId }`,
		method: 'GET'
	},
});

export const getJobs = ({ page, pageSize, sort, filters, distinct, calcAttempts }) => {

	const q = qs.stringify({
		page,
		pageSize,
		sort,
		filters,
		distinct: distinct ? 1 : 0,
		calcAttempts: calcAttempts ? 1 : 0,
		tzMinutes: (new Date()).getTimezoneOffset(),
	});

	return {
		type: types.GET_JOBS,
		meta: {
			async: true,
			endPoint: `/jobs/getJobs/?${ q }`,
			method: 'GET',
		},
	};
};

export const postImportJobs = (formData, byPassLoading = false) => ({
	type: types.POST_IMPORT_JOBS,
	meta: {
		async: true,
		endPoint: `/jobs/import`,
		method: 'POST',
		body: formData,
		headers: { 'Content-Type': 'multipart/form-data' },
		byPassLoading,
	}
});

export const postAssignJobs = (data, byPassLoading = false) => ({
	type: types.POST_ASSIGN_JOBS,
	meta: {
		async: true,
		endPoint: `/jobs/assign`,
		method: 'POST',
		body: data,
		byPassLoading,
	},
});

export const fetchAssigned = (username, date) => ({
	type: types.FETCH_ASSIGNED,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/getAssigned`,
		method: 'GET'
	},
});

export const postCompleteTask = (username, date, jobId, locationId, type, data) => ({
	type: types.POST_COMPLETE_TASK,
	meta: {
		async: true,
		endPoint: `/jobs/${ jobId }/${ locationId }/completeTask`,
		method: 'POST',
		body: { type, data },
		params: { username, date },
	}
});

export const postUncompleteTask = (username, date, jobId, locationId, type, attemptId) => ({
	type: types.POST_UNCOMPLETE_TASK,
	meta: {
		async: true,
		endPoint: `/jobs/${ jobId }/${ locationId }/uncompleteTask`,
		method: 'POST',
		body: { type, attemptId },
		params: { username, date },
	}
});
